if (Array && !Array.wrap) {
  Array.wrap = function(value) {
    if (typeof value === 'undefined')
      return value;
    if (value instanceof Array)
      return value;
    return [ value ];
  };
}
